<app-header></app-header>

<section class="inerpages-banner">
    <img src="assets/img/about-us-background.jpg" class="w-100" alt="">
    <div class="fade-bg"></div>
    <div class="mask-content-v-center text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="tbox-iner text-center animate zoomIn" data-anim-type="zoomIn">
                        <div class="heading-iner">
                            <h2>Reserve</h2>
                            <hr>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="reservation-section">
    <div class="container-fluid">
       <div class="row">
        <div class="col-lg-6 mx-auto">
            <form (ngSubmit)="frm.valid && onFrmSubmit(frm)" #frm="ngForm">
                <div class="form-group">
                    <label for="name">Name:</label>
                    <input type="text" class="form-control" id="name" name="name" ngModel required #name="ngModel">
                    <span class="errcls" *ngIf="!name.valid && name.touched">Please enter your full name.</span>
                </div>
    
                <div class="form-group">
                  <label for="email">Email:</label>
                  <input type="email" class="form-control" id="email" name="email" ngModel required #email="ngModel" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$">
                  <span class="errcls" *ngIf="!email.valid && email.touched">Please enter a valid email.</span>
                </div>
                <div class="form-group">
                  <label for="phone">Phone No. :</label>
                <span class="country-code">971</span>
                  <input type="number" class="form-control number" placeholder="50 123 4567" id="phone" name="phone" ngModel required #phone="ngModel">
                  <span class="errcls" *ngIf="!phone.valid && phone.touched">Please Enter your phone no.</span>
                </div>
    
                <div class="form-group">
                    
                    <label for="no_people">No. Of People:</label>
                    <input type="number" class="form-control" id="no_people" name="no_people" ngModel required #no_people="ngModel">
                    <span class="errcls" *ngIf="!no_people.valid && no_people.touched">Please enter the no. of people</span>
                
                </div>
    
                <!-- <div class="form-group">
                    <label class="d-block" for="email">Gender:</label>
                

                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio"  value="male" name="gender" id="exampleRadios1"  checked ngModel  #gender="ngModel">
                        <label class="form-check-label" for="exampleRadios1">
                          Male
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="female" name="gender" id="exampleRadios2"  ngModel  #gender="ngModel">
                        <label class="form-check-label" for="exampleRadios2">
                          Female
                        </label>
                        
                      </div>
                </div> -->
                    
                <!-- <div class="form-group row">
                    <div class="col-md-6">
                    <label for="no_male">No. Of Male:</label>
                    <input type="number" class="form-control" id="no_male" name="no_male" ngModel required #no_male="ngModel">
                    <span class="errcls" *ngIf="frm.submitted && no_male.errors?.required">Please enter no. of male.</span>
                </div>
                <div class="col-md-6 mt-2 mt-md-0">
                    <label for="no_female">No. Of Female:</label>
                    <input type="number" class="form-control" id="no_female" name="no_female" ngModel required #no_female="ngModel">
                    <span class="errcls" *ngIf="frm.submitted && no_female.errors?.required">Please enter no. of female.</span>
                </div>
                </div> -->
            
    
               
    
                <!-- <div class="form-group">
                    <label for="eventname">Event Name:</label>
                    <input type="email" class="form-control" id="eventname" name="eventname" ngModel required #eventname="ngModel">
                    <span class="errcls" *ngIf="frm.submitted && eventname.errors?.required">Please enter event name.</span>
                </div> -->
    
                <div class="form-group row">
                    <div class="col-md-6">
                    <label for="date">Date:</label>
                    <input type="date" class="form-control" id="date" name="date" ngModel required #date="ngModel">
                    <span class="errcls" *ngIf="!date.valid && date.touched">Please select date.</span>
                </div>
                <div class="col-md-6 mt-2 mt-md-0">
                <div class="row">
                    <div class="col-8 c pr-0">
                    <label for="ar_time">Arrival Time:</label>
                    <input type="email" class="form-control" id="ar_time" name="ar_time" ngModel required #ar_time="ngModel">
                    <span class="errcls" *ngIf="!ar_time.valid && ar_time.touched">Please enter the arrival time.</span>
                </div>
                
                <div class="col-4">
                    <label class="blank-lebel" for=""></label>
                    <select class="form-control" name="ampm" ngModel required #ampm="ngModel">
                        <option selected>AM</option>
                        <option value="PM">PM</option>
                    </select>
                </div>
                </div>      
                </div>
                </div>

                <div class="form-group">
                    <label for="msg">Message:</label>
                    <textarea name="message" class="form-control" name="message" ngModel required #message="ngModel" ></textarea>
                    <span class="errcls" *ngIf="!message.valid && message.touched">Please enter the message.</span>
                </div>

                <div class="mb-3" *ngIf="isError">
                    <span class="errclsmain">{{formmsg}}</span>
                </div>
                
                <div *ngIf="isSuccess">
                    <span class="sucmsg"> {{formmsg}} </span><br>
                </div>
    
                <button type="submit" class="btn btn-lg btn-primary orderonline">Submit
                    <span *ngIf="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </span>
                </button>
              </form>
           </div>
    </div>
    </div>
</section>